import { FC } from 'react';
import {
  Card,
  IconButton,
  Spacer,
  TextSubtitle,
  Image,
} from '@pypestream/design-system';
import { useTranslation } from '@pypestream/translations';

import { sendProStudioEvent } from '../../xstate/app.xstate';
import { useDeleteFilePopover } from '..';

import './asset-card.scss';

const fallbackImg =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYxIiBoZWlnaHQ9IjE2MCIgdmlld0JveD0iMCAwIDE2MSAxNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjU5OTYwOSA0QzAuNTk5NjA5IDEuNzkwODYgMi4zOTA0NyAwIDQuNTk5NjEgMEgxNTYuNkMxNTguODA5IDAgMTYwLjYgMS43OTA4NiAxNjAuNiA0VjE1NkMxNjAuNiAxNTguMjA5IDE1OC44MDkgMTYwIDE1Ni42IDE2MEg0LjU5OTYxQzIuMzkwNDcgMTYwIDAuNTk5NjA5IDE1OC4yMDkgMC41OTk2MDkgMTU2VjRaIiBmaWxsPSIjQ0VDN0Y1IiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8ZyBvcGFjaXR5PSIwLjEiPgo8cmVjdCB4PSIxNi41OTk2IiB5PSIxNiIgd2lkdGg9IjEyOCIgaGVpZ2h0PSIxMjgiIHJ4PSIyOCIgZmlsbD0iIzE1MUEyNSIvPgo8L2c+CjxnIG9wYWNpdHk9IjAuMiI+CjxyZWN0IHg9IjU2LjU5OTYiIHk9IjU2IiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHJ4PSIyNCIgZmlsbD0iIzE1MUEyNSIvPgo8L2c+Cjwvc3ZnPgo=';

interface AssetCardProps {
  id: string;
  url: string;
  testId: string;
}

export const AssetCard: FC<AssetCardProps> = ({ id, url, testId }) => {
  const [t] = useTranslation();
  const deleteAsset = (assetId: string) => {
    sendProStudioEvent({
      type: 'deleteAsset',
      id: assetId,
    });
  };

  const copyAssetUrl = (assetUrl: string) => {
    sendProStudioEvent({
      type: 'copyToClipboard',
      value: assetUrl,
      // TODO: translate
      message: 'Asset`s url copied to clipboard',
    });
  };

  const { deleteFilePopover, trigger } = useDeleteFilePopover({
    title:
      t('pro-studio/files:deleteFilePopover.title', {
        defaultValue: 'Are you sure you want to delete this asset?',
      }) || '',
    onDelete: () => deleteAsset(id),
  });

  return (
    <>
      <Card test-id={testId} key={id} border="default" className="c-asset-card">
        <IconButton
          id={trigger}
          slot="hover-action-start"
          size="small"
          name="delete"
        />
        <IconButton
          slot="hover-action"
          size="small"
          name="copy"
          onClick={() => copyAssetUrl(url)}
        />
        <Image
          width="160"
          height="160"
          src={url || ''}
          fallback={fallbackImg}
          alt={`uploaded asset: ${id}`}
        />
        <Spacer />
        <div className="c-asset-card__title">
          <TextSubtitle size="small" truncate-lines="2" title={id}>
            {id}
          </TextSubtitle>
        </div>
      </Card>
      {deleteFilePopover}
    </>
  );
};
